// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2025 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import * as React from "react";

const HeaderUtilitySwitchAccount: React.FC<{
    width?: number;
    height?: number;
    color1?: string;
    className?: string;
}> = ({ width = undefined, height = undefined, color1 = "#fff", className }) => {
    return (
        <svg className={className} focusable="false" viewBox="0 0 15 13" width={width} height={height}>
            <path
                fill="currentColor"
                d="M2.25 2.375a1.125 1.125 0 1 1 2.25 0 1.125 1.125 0 0 1-2.25 0m3 0a1.875 1.875 0 1 0-3.75 0 1.875 1.875 0 0 0 3.75 0M7.5 4.25a1.5 1.5 0 1 1 0 3 1.5 1.5 0 0 1 0-3M7.5 8a2.25 2.25 0 1 0 0-4.5 2.25 2.25 0 0 0 0 4.5M6.124 9.5h2.752c1.27 0 2.306.996 2.372 2.25H3.752A2.375 2.375 0 0 1 6.124 9.5m0-.75A3.125 3.125 0 0 0 3 11.874c0 .345.279.626.626.626h7.748a.626.626 0 0 0 .626-.626c0-1.725-1.4-3.124-3.124-3.124zM12 1.25a1.125 1.125 0 1 1 0 2.25 1.125 1.125 0 0 1 0-2.25m0 3A1.875 1.875 0 1 0 12 .5a1.875 1.875 0 0 0 0 3.75m.375 1.5c1.036 0 1.875.84 1.875 1.875 0 .206.169.375.375.375A.376.376 0 0 0 15 7.625 2.624 2.624 0 0 0 12.375 5h-1.969q.093.361.094.75zm-7.875 0q.001-.389.094-.75H2.625A2.624 2.624 0 0 0 0 7.625C0 7.831.169 8 .375 8a.376.376 0 0 0 .375-.375c0-1.036.84-1.875 1.875-1.875z"
            />
        </svg>
    );
};

export default React.memo(HeaderUtilitySwitchAccount);
